/* eslint-disable no-case-declarations */
import {
  CONTACTS_EDIT_SIDE_PANEL,
  GLOBAL_CONTACTS,
  GLOBAL_CONTACTS_ADD_NEW_CONTACTS,
  GLOBAL_CONTACTS_DELETE_CONTACTS,
  GLOBAL_CONTACTS_SEARCH,
  GLOBAL_CONTACTS_SELECTION,
  GLOBAL_CONTACTS_UPDATE_CONTACTS,
  GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST,
  GLOBAL_CONTACTS_REMOVED_FROM_LIST,
  GLOBAL_CONTACTS_ADD_TO_LIST_MODE,
} from 'constants/types/audienceTypesNew';
import { IGlobalContactsReducerAction, IGlobalContactsReducerStore } from '../interfaces2';
import { IContactItem } from '../interface';

const audienceListsInitialState: IGlobalContactsReducerStore = {
  loading: false,
  page: 0,
  contacts: [],
  totalContacts: 0,
  newContactAdded: false,
  // search scenario
  searchTerm: '',
  searchLoading: false,
  searchedPage: 0,
  searchedContacts: [],
  totalSearchedContacts: 0,
  totalContactsNotInList: 0,
  isSorted: false,
  totalSearchedContactsNotInList: 0,
  fromWorkFlow: false,
  // add new|update|delete contact scenario
  addNewContacts: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  deleteContacts: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  updateContacts: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  addToListContacts: {
    loading: false,
    success: false,
    error: false,
    message: '',
  },
  addToListGlobalMode: false,
  // recently added contacts
  recentlyAddedContacts: [],
  openEditContactSidebar: false,
  currentActiveList: '',
  isGlobalContactsSelected: false,
  removeAllList: false,
};

export const globalContactsReducerStore = (
  state: IGlobalContactsReducerStore = audienceListsInitialState,
  action: IGlobalContactsReducerAction,
) => {
  const newState = { ...state };
  switch (action.type) {
    // * get all contacts scenarios for global contacts
    case GLOBAL_CONTACTS.LOAD:
      newState.loading = true;
      return newState;

    case GLOBAL_CONTACTS.SUCCESS:
      newState.loading = false;
      if (action.payload.offset === 0) {
        newState.contacts = action.payload.contacts as IContactItem[];
        newState.totalContacts = action.payload.totalContacts as number;
        newState.totalContactsNotInList = action.payload.totalContactsNotInList as number;
      } else {
        newState.contacts = [...newState.contacts, ...(action.payload.contacts as IContactItem[])];
      }
      return newState;

    case GLOBAL_CONTACTS.STAGE_UPDATE:
      newState.searchedContacts = newState.searchedContacts.map((contact) =>
        contact.contactId === action.payload.contact_id
          ? { ...contact, buyerStage: action.payload.searchBuyerStage as string }
          : contact,
      );
      return newState;

    case GLOBAL_CONTACTS.FAIL:
      newState.loading = false;
      return newState;

    case GLOBAL_CONTACTS.RESET:
      newState.loading = false;
      newState.page = 0;
      newState.contacts = [];
      newState.totalContacts = 0;
      return newState;

    case GLOBAL_CONTACTS.SORT_LIST:
      newState.loading = true;
      newState.page = 0;
      newState.contacts = [];
      newState.isSorted = true;
      return newState;

    case GLOBAL_CONTACTS.RESET_SORT:
      newState.isSorted = false;
      return newState;

    //* search scenarios for global contacts

    case GLOBAL_CONTACTS_SEARCH.SET_SEARCH_TERM:
      newState.searchTerm = action.payload.searchTerm as string;
      return newState;

    case GLOBAL_CONTACTS_SEARCH.LOAD:
      newState.searchLoading = true;
      return newState;

    case GLOBAL_CONTACTS_SEARCH.SUCCESS:
      newState.searchLoading = false;
      if (action.payload.offset === 0) {
        newState.searchedContacts = action.payload.contacts as IContactItem[];
        newState.totalSearchedContacts = action.payload.totalContacts as number;
        newState.totalSearchedContactsNotInList = action.payload.totalContactsNotInList as number;
      } else {
        newState.searchedContacts = [...newState.searchedContacts, ...(action.payload.contacts as IContactItem[])];
      }
      return newState;

    case GLOBAL_CONTACTS_SEARCH.STAGE_UPDATE:
      newState.contacts = newState.contacts.map((contact) =>
        contact.contactId === action.payload.contact_id
          ? { ...contact, buyerStage: action.payload.buyer_stage as string }
          : contact,
      );
      return newState;

    case GLOBAL_CONTACTS.REMOVE_ALL_LIST:
      newState.removeAllList = action.payload.flag as boolean;
      return newState;

    case GLOBAL_CONTACTS_SEARCH.FAIL:
      newState.searchLoading = false;
      return newState;

    case GLOBAL_CONTACTS_SEARCH.RESET:
      newState.searchLoading = false;
      newState.searchedPage = 0;
      newState.searchedContacts = [];
      newState.totalSearchedContacts = 0;
      // newState.searchTerm = '';
      return newState;

    case GLOBAL_CONTACTS_SEARCH.SORT_LIST:
      newState.searchLoading = true;
      newState.searchedPage = 0;
      newState.searchedContacts = [];
      newState.isSorted = true;
      return newState;

    //* add new contact scenarios for global contacts

    case GLOBAL_CONTACTS_ADD_NEW_CONTACTS.LOAD:
      newState.addNewContacts.loading = true;
      return newState;

    case GLOBAL_CONTACTS_ADD_NEW_CONTACTS.SUCCESS:
      newState.addNewContacts.loading = false;
      newState.addNewContacts.success = true;
      newState.addNewContacts.message = action.payload.message as string;
      newState.contacts = [...(action.payload.contacts as IContactItem[]), ...newState.contacts];
      newState.totalContacts += (action.payload.contacts as IContactItem[]).length;
      newState.newContactAdded = true;
      return newState;

    case GLOBAL_CONTACTS_ADD_NEW_CONTACTS.FAIL:
      newState.addNewContacts.loading = false;
      newState.addNewContacts.error = true;
      newState.addNewContacts.message = action.payload.message as string;
      return newState;

    case GLOBAL_CONTACTS_ADD_NEW_CONTACTS.RESET:
      newState.addNewContacts.loading = false;
      newState.addNewContacts.error = false;
      newState.addNewContacts.success = false;
      newState.addNewContacts.message = '';
      return newState;

    case GLOBAL_CONTACTS_ADD_NEW_CONTACTS.RESET_NEW_CONTACT_ADDED:
      newState.newContactAdded = false;
      return newState;

    case GLOBAL_CONTACTS_ADD_NEW_CONTACTS.SET_RECENTLY_ADDED_CONTACTS:
      newState.recentlyAddedContacts = action.payload.recentlyAddedContacts as IContactItem[];
      return newState;

    //* update contact scenarios for global contacts

    case GLOBAL_CONTACTS_UPDATE_CONTACTS.LOAD:
      newState.updateContacts.loading = true;
      return newState;

    case GLOBAL_CONTACTS_UPDATE_CONTACTS.SUCCESS:
      newState.updateContacts.loading = false;
      newState.updateContacts.success = true;
      newState.updateContacts.message = action.payload.message as string;
      const updatedContactId = action.payload.contactId as number;
      const updatedContactIndex = newState.contacts.findIndex((contact) => contact.contactId === updatedContactId);
      if (updatedContactIndex !== -1) {
        const updatedContacts = [...newState.contacts];
        const previousVersion = updatedContacts[updatedContactIndex];
        const updatedNewVersion = { ...previousVersion, ...(action?.payload.contact as unknown) } as IContactItem;
        updatedContacts[updatedContactIndex] = { ...newState.contacts[updatedContactIndex], ...updatedNewVersion };
        newState.contacts = [...updatedContacts];
      }
      if (newState.searchTerm) {
        const updatedSearchedContactIndex = newState.searchedContacts.findIndex(
          (contact) => contact.contactId === updatedContactId,
        );
        if (updatedSearchedContactIndex !== -1) {
          const previousVersion = newState.searchedContacts[updatedSearchedContactIndex];
          const updatedNewVersion = { ...previousVersion, ...(action.payload.contact as unknown) } as IContactItem;
          newState.searchedContacts[updatedSearchedContactIndex] = updatedNewVersion;
        }
      }
      return newState;

    case GLOBAL_CONTACTS_UPDATE_CONTACTS.FAIL:
      newState.updateContacts.loading = false;
      newState.updateContacts.error = true;
      newState.updateContacts.message = action.payload.message as string;
      return newState;

    case GLOBAL_CONTACTS_UPDATE_CONTACTS.RESET:
      newState.updateContacts.loading = false;
      newState.updateContacts.error = false;
      newState.updateContacts.success = false;
      newState.updateContacts.message = '';
      return newState;

    //* delete contact scenarios for global contacts

    case GLOBAL_CONTACTS_DELETE_CONTACTS.LOAD:
      newState.deleteContacts.loading = true;
      return newState;

    case GLOBAL_CONTACTS_DELETE_CONTACTS.SUCCESS: {
      // eslint-disable-next-line
      const { message, deleteAll, contactIds } = action.payload;
      let { excludedContactIds } = action.payload;
      excludedContactIds = excludedContactIds as number[];
      if (deleteAll && excludedContactIds.length > 0) {
        const ids = excludedContactIds;
        if (newState.searchTerm !== '') {
          const filteredSearchedContacts = newState.searchedContacts.filter((contact) =>
            ids.includes(contact.contactId),
          );
          const contactsToRemove = newState.searchedContacts
            .filter((contact) => !ids.includes(contact.contactId))
            .map((removedContact) => removedContact.contactId);
          const filteredContacts = newState.contacts.filter((contact) => !contactsToRemove.includes(contact.contactId));
          newState.contacts = filteredContacts;
          newState.totalContacts -= newState.totalSearchedContacts - ids.length;
          newState.searchedContacts = filteredSearchedContacts;
          newState.totalSearchedContacts = filteredSearchedContacts.length;
        } else {
          const filteredContacts = newState.contacts.filter((contact) => ids.includes(contact.contactId));
          newState.contacts = filteredContacts;
          newState.totalContacts = filteredContacts.length;
        }
      } else if (deleteAll) {
        if (newState.searchTerm !== '') {
          newState.totalContacts -= newState.totalSearchedContacts;
          newState.searchedContacts = [];
          newState.totalSearchedContacts = 0;
        } else {
          newState.contacts = [];
          newState.totalContacts = 0;
        }
      } else {
        const ids = contactIds as number[];
        if (newState.searchTerm !== '') {
          const filteredSearchedContacts = newState.searchedContacts.filter(
            (contact) => !ids.includes(contact.contactId),
          );
          const filteredContacts = newState.contacts.filter((contact) => !ids.includes(contact.contactId));
          newState.searchedContacts = filteredSearchedContacts;
          newState.totalSearchedContacts -= ids.length;
          newState.contacts = filteredContacts;
          newState.totalContacts -= ids.length;
        } else {
          const filteredContacts = newState.contacts.filter((contact) => !ids.includes(contact.contactId));
          newState.contacts = filteredContacts;
          newState.totalContacts -= ids.length;
        }
      }
      newState.deleteContacts.loading = false;
      newState.deleteContacts.success = true;
      newState.deleteContacts.message = message as string;
      return newState;
    }

    case GLOBAL_CONTACTS_DELETE_CONTACTS.FAIL:
      newState.deleteContacts.loading = false;
      newState.deleteContacts.error = true;
      newState.deleteContacts.message = action.payload.message as string;
      return newState;

    case GLOBAL_CONTACTS_DELETE_CONTACTS.RESET:
      newState.deleteContacts.loading = false;
      newState.deleteContacts.error = false;
      newState.deleteContacts.success = false;
      newState.deleteContacts.message = '';
      return newState;

    // Add To List Logic
    case GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST.LOAD:
      newState.addToListContacts.loading = true;
      return newState;

    case GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST.SUCCESS: {
      // eslint-disable-next-line
      const { message, deleteAll, contactIds } = action.payload;
      let { excludedContactIds } = action.payload;
      excludedContactIds = excludedContactIds as number[];
      if (deleteAll && excludedContactIds.length > 0) {
        const ids = excludedContactIds;
        const filteredSearchedContacts = newState.searchedContacts.map((filteredContact) => {
          if (ids.includes(filteredContact.contactId)) {
            return filteredContact;
          }
          return { ...filteredContact, isListContact: true };
        });
        newState.searchedContacts = filteredSearchedContacts;

        // The below block will only run for addToList via button.
        if (newState.addToListGlobalMode) {
          const filteredContacts = newState.contacts.map((filteredContact) => {
            if (ids.includes(filteredContact.contactId)) {
              return filteredContact;
            }
            return { ...filteredContact, isListContact: true };
          });

          if (newState.searchTerm !== '') {
            newState.totalSearchedContactsNotInList = ids.length;
          } else {
            newState.totalContactsNotInList = ids.length;
          }

          newState.contacts = filteredContacts;
        }
      } else if (deleteAll) {
        newState.searchedContacts = newState.searchedContacts.map((contact) => ({ ...contact, isListContact: true }));
        // The below block will only run for addToList via button.
        if (newState.addToListGlobalMode) {
          if (newState.searchTerm !== '') {
            newState.totalSearchedContactsNotInList = 0;
            newState.contacts = newState.searchedContacts.map((contact) => ({ ...contact, isListContact: true }));
          } else {
            newState.totalContactsNotInList = 0;
            newState.contacts = newState.contacts.map((contact) => ({ ...contact, isListContact: true }));
          }
        }
      } else {
        const ids = contactIds as number[];
        const filteredSearchedContacts = newState.searchedContacts.map((contact) => {
          if (ids.includes(contact.contactId)) {
            return { ...contact, isListContact: true };
          }
          return contact;
        });

        // The below block will only run for addToList via button.
        if (newState.addToListGlobalMode) {
          const filteredContacts = newState.contacts.map((contact) => {
            if (ids.includes(contact.contactId)) {
              return { ...contact, isListContact: true };
            }
            return contact;
          });

          if (newState.searchTerm !== '') {
            newState.totalSearchedContactsNotInList -= ids.length;
          } else {
            newState.totalContactsNotInList -= ids.length;
          }

          newState.contacts = filteredContacts;
        }

        newState.searchedContacts = filteredSearchedContacts;
      }
      newState.addToListContacts.loading = false;
      newState.addToListContacts.success = true;
      newState.newContactAdded = true;
      newState.addToListContacts.message = message as string;
      return newState;
    }

    case GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST.FAIL:
      newState.addNewContacts.loading = false;
      newState.addNewContacts.error = true;
      newState.addNewContacts.message = action.payload.message as string;
      return newState;

    // Removed contacts from list
    case GLOBAL_CONTACTS_REMOVED_FROM_LIST.REMOVE:
      // eslint-disable-next-line
      const { deleteAll, contactIds } = action.payload;
      let { excludedContactIds } = action.payload;
      excludedContactIds = excludedContactIds as number[];
      if (deleteAll && excludedContactIds.length > 0) {
        const ids = excludedContactIds;
        if (newState.searchTerm !== '') {
          const filteredSearchedContacts = newState.searchedContacts.map((filteredContact) => {
            if (ids.includes(filteredContact.contactId)) {
              return filteredContact;
            }
            return { ...filteredContact, isListContact: false };
          });
          newState.searchedContacts = filteredSearchedContacts;
        }
      } else if (deleteAll) {
        if (newState.searchTerm !== '') {
          newState.searchedContacts = newState.searchedContacts.map((contact) => ({
            ...contact,
            isListContact: false,
          }));
        }
      } else {
        const ids = contactIds as number[];
        if (newState.searchTerm !== '') {
          const filteredSearchedContacts = newState.searchedContacts.map((contact) => {
            if (ids.includes(contact.contactId)) {
              return { ...contact, isListContact: false };
            }
            return contact;
          });
          newState.searchedContacts = filteredSearchedContacts;
        }
      }
      return newState;

    case 'UPDATE_CURRENT_ACTIVE_LIST':
      newState.currentActiveList = action.payload.activeList as string;
      return newState;

    // Add contacts to list Via Button
    case GLOBAL_CONTACTS_ADD_TO_LIST_MODE.ADD_MODE:
      newState.addToListGlobalMode = action.payload.mode as boolean;
      return newState;

    case GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST.RESET:
      newState.addNewContacts.loading = false;
      newState.addNewContacts.error = false;
      newState.addNewContacts.success = false;
      newState.addNewContacts.message = '';
      return newState;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    case CONTACTS_EDIT_SIDE_PANEL.OPEN:
      newState.openEditContactSidebar = true;
      return newState;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    case CONTACTS_EDIT_SIDE_PANEL.CLOSE:
      newState.openEditContactSidebar = false;
      return newState;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    case GLOBAL_CONTACTS_SELECTION.SET:
      newState.isGlobalContactsSelected = true;
      return newState;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    case GLOBAL_CONTACTS_SELECTION.RESET:
      newState.isGlobalContactsSelected = false;
      return newState;

    case 'Reset_WORKFLOW_AUDIENCE':
      newState.fromWorkFlow = action.payload.isFromWorkflow as boolean;
      return newState;

    default:
      return newState;
  }
};
